var exports = {
  "g": "BaseCell__94WG2w",
  "r": "wrapping__0qdClq",
};

module.exports = exports;
